exports.value = "v3.1.8-hotfix.5";